import { useState, useRef } from "react";
import Profile from "./Profile";
import Notifications from "./Notifications";
import "./styles.scss";
import { useOutsideClick } from "hooks/useOutsideClick";

const Settings = ({
  toggleSettings,
  handleCloseSettings,
  setShowLogoutModal,
}) => {
  const [selectedItem] = useState("profile");
  const wrapperRef = useRef(null);

  useOutsideClick(wrapperRef, () => {
    handleCloseSettings();
  });

  return (
    <div ref={wrapperRef} className="settings_container">
      <div className="settings_content">
        {selectedItem === "profile" && (
          <Profile
            handleCloseSettings={handleCloseSettings}
            setShowLogoutModal={setShowLogoutModal}
            toggleSettings={toggleSettings}
          />
        )}
        {selectedItem === "notification" && <Notifications />}
      </div>
    </div>
  );
};

export default Settings;
